// extracted by mini-css-extract-plugin
export default {"mainPage":"orderConfirmation_mainPage__8Uat0","title":"orderConfirmation_title__xUzb-","message":"orderConfirmation_message__nL5uu","signature":"orderConfirmation_signature__mUD3v"};